import { Stack, Typography } from '@mui/material';
import { styled } from '@mui/material/styles';
import { IChatConversation } from 'src/@types/chat';
import Iconify from 'src/components/iconify';
import { useLocales } from 'src/locales';

export const ChannelIcon = styled('div')(({ theme }) => ({
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  borderRadius: theme.shape.borderRadius,
  border: `1px solid ${theme.palette.divider}`,
  fontSize: '2rem',
  lineHeight: 1,
  color: theme.palette.primary.main,
  width: theme.spacing(6),
  height: theme.spacing(6),
}));

export const StyledChatInitialStateContainer = styled('div')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'flex-end',
  flexGrow: 1,
  padding: theme.spacing(4, 3, 2),
  marginBottom: theme.spacing(5),
  gap: theme.spacing(2),
}));

type Props = {
  conversation?: IChatConversation;
};

export const GatheringChatEmptyMessages = () => {
  const { translate } = useLocales();
  return (
    <StyledChatInitialStateContainer>
      <ChannelIcon>
        <Iconify icon="tabler:file-text" />
      </ChannelIcon>
      <Typography variant="h4">
        {translate('communicate.gathering.empty_messages_title')}
      </Typography>
      <Stack
        direction="row"
        alignItems="center"
        color="text.secondary"
        gap={0.5}
      >
        <Typography>
          <Typography variant="h5">
            {translate('communicate.gathering.send_the_first_message')}
          </Typography>
        </Typography>
      </Stack>
    </StyledChatInitialStateContainer>
  );
};
